import React from "react";
import { PrivacyCheckbox, TermsList } from "../../privacyCheckbox";
import { PrivacyPolicyButton } from "../../../../../components/privacyPolicyButton/privacyPolicyButton";
import environmentSettings from "@constants/environmentSettings";

export const AcceptsPrivacyPolicy = () => {
  const { privacy, companyName, privacyConsentAndElectronicAuthorisation, creditGuide } = environmentSettings;

  const openPrivacyPolicyPage = (event) => {
    window.open(privacy, "_blank");
    event.stopPropagation();
  };

  const openPrivacyConsentAndElectronicAuthorisationPage = (event) => {
    window.open(privacyConsentAndElectronicAuthorisation, "_blank");
    event.stopPropagation();
  };

  const openCreditGuidePage = (event) => {
    window.open(creditGuide, "_blank");
    event.stopPropagation();
  };

  return (
    <PrivacyCheckbox name="acceptsPrivacyPolicy" title="I consent to MANDATORY CREDIT ACTIVITIES:">
      {
        <TermsList>
          <ol>
            <li>
              ACCESSING MY CREDIT REPORT: I agree to the{" "}
              <PrivacyPolicyButton onClick={openPrivacyPolicyPage}>
                Privacy Policy
              </PrivacyPolicyButton>{" "}
              and that {companyName} may exchange my personal, sensitive
              and credit information with credit reporting bodies in order
              to obtain a copy of my credit file from credit reporting
              bodies and assess this application and verify my identity
              and I understand that even if I do not enter into a credit
              contract with {companyName}, this may affect the decision
              of another lender to provide me with credit and the terms
              on which credit is offered. 
            </li>
            <li>
              ELECTRONIC COMMUNICATIONS: To, and confirm that I have read,
              understood and agree to the terms of the{" "}
              <PrivacyPolicyButton onClick={openPrivacyConsentAndElectronicAuthorisationPage}>
                Privacy Consent and Electronic Authorisation
              </PrivacyPolicyButton>{" "}
               and to the collection, use, holding and disclosure of my personal,
               sensitive and credit related information as well as electronic
               communication.
            </li>
            <li>
              RECEIVING PRELIMINARY INFORMATION: I have accessed and read the{" "}
              <PrivacyPolicyButton onClick={openCreditGuidePage}>
                Credit Guide
              </PrivacyPolicyButton>
              . 
            </li>
            <li>
              SHARING INFORMATION WITHIN OUR GROUP OF COMPANIES: To my personal,
              sensitive and credit information being shared with {companyName}'s
              related bodies corporate, including Fintech Services (Aust).Pty Ltd
              for analysis purposes.  
            </li>
            <li>
              ELECTRONIC BANK STATEMENTS: To {companyName} using a third-party
              service provider to access my nominated bank accounts to obtain
              bank statements both:
              <ul>
                <li>for the purposes of assessing this current application for credit; and </li>
                <li>on an ongoing basis to confirm my continuing eligibility for credit products and withdrawals.</li>
              </ul>
            </li>
        </ol>
        </TermsList>
      }
    </PrivacyCheckbox>
  );
};

